export default __webpack_public_path__ + "static/media/tituloEN.e4b6c3f4.png";